import ajvErrors from 'ajv-errors';
import Ajv from 'ajv/dist/2020';
import {
  EMAIL_VALIDATION_REGEX,
  URL_VALIDATION_REGEX,
} from './constants/regex';

export const ajv = new Ajv({
  strict: 'log',
  strictSchema: 'log',
  allErrors: true,
  validateSchema: false,
});
ajv.addFormat('email', EMAIL_VALIDATION_REGEX);
ajv.addFormat('url', URL_VALIDATION_REGEX);
ajv.addVocabulary([
  'metadata',
  'payaca:identifier',
  'payaca:label',
  'payaca:field-type',
  'payaca:sort-index',
  'payaca:description',
]);
ajvErrors(ajv);
